<template>
  <div>
    <video-player
      ref="player"
      :item="videoItem"
      :active="true"
      :popup="false"
      :taking="false"
      :testing="false"
      :options="clientPlayerOptions"
      @pause="pause"
      @played="play"
    />

    <div class="entertain-menu-bar pa-3">
      <div class="volume-controls">Volume Controls ☝🏽</div>
    </div>
  </div>
</template>

<script>
import VideoPlayer from '@/views/lessons/lessonWidgets/videoWidget/VideoPlayer';

export default {
  name: 'ActionVideoContent',
  components: {
    VideoPlayer,
  },
  props: {
    state: {},
  },
  data() {
    return {
      clientPlayerOptions: {
        presentMode: true,
        autoPlay: false,
      },
    };
  },
  computed: {
    videoItem() {
      return {
        values: {
          url: this.state.videoUrl,
          summary: {},
        },
      };
    },
  },
  watch: {
    state: {
      immediate: true,
      handler() {
        this.handleHostAction(this.state.action);
      },
    },
  },
  methods: {
    pause() {
      if (this.state?.playerStatus === 'play') {
        this.callOnRef((ref) => {
          ref.play();
        });
      }
    },

    play() {
      if (this.state?.playerStatus === 'pause') {
        this.callOnRef((ref) => {
          ref.pause();
        });
      }
    },

    handleHostAction() {
      const action = this.state.action;
      const actionCallbacks = {
        play: (ref) => {
          ref.play();
        },
        seek: (ref) => {
          ref.sync(1, this.state.seconds);
          if (this.state.playerStatus) {
            ref[this.state.playerStatus]();
          }
        },
        pause: (ref) => {
          ref.pause();
        },
      };

      if (!action || !actionCallbacks[action]) {
        return;
      }

      this.callOnRef((ref) => {
        actionCallbacks[action](ref);
      });
    },

    callOnRef(callback) {
      this.$nextTick(() => {
        let ref = this.$refs.player;
        if (!ref) {
          console.log('no ref yet');
          return;
        }

        callback(ref);
      });
    },
  },
};
</script>

<style>
.entertain-menu-bar {
  background: var(--v-appMain-base);
  margin-right: 0;
  margin-left: 0;
  min-height: 46px;
}
.volume-controls {
  /*font-size: .5em;*/
  color: #fff;
  float: right;
  min-height: 40px;
  vertical-align: middle;
  display: inline-block;
}
</style>
